import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';
import { WorkOrderService } from '@app/services/work-order.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'formly-field-button-without-delete',
  template: `
    <div>
      <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onClick($event,to.url)">
        {{ to.text }}
      </button>
      <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onPreview($event,to.url)"
        style="float: right;">
        <i class="material-icons left">visibility</i>
      </button>
    </div>
  `,
})
export class FormlyFieldButtonWithoutDelete extends FieldType {

  constructor(private workOrderService:WorkOrderService) {
    super();
  }
  onClick($event,url) {
    this.workOrderService.download(url).subscribe(response=>{
      console.log('Descargando el archivo como es');
      let fileName: string = url.substr(url.lastIndexOf('/')+1, url.length);
      const file = new File([response], fileName, { type: response.type });
      saveAs(file);
    }),error=>{
      console.log('No se pudo descargar el archivo');
    },
    () => console.info('Archivo descargado correctamente');
  }

  onPreview($event: any, url: string) {
    window.open(this.workOrderService.getDownloadURL(url));
  }
}
